import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  en: {
    translation: {
      nav: {
        home: 'Home',
        pavers: 'Pavers',
        brickColors: 'Brick Colors',
        remodeling: 'Remodeling',
        projects: 'Projects',
        about: 'About',
        contact: 'Contact',
        shop: 'Shop'
      },
      hero: {
        title: 'Premium Paver Solutions That Elevate Your Property',
        titleHighlight: 'with Premium Brick Pavers',
        subtitle: 'Expert brick pavers and high-end exterior solutions for residential and commercial projects',
        cta: 'Get a Free Estimate',
        viewServices: 'View Our Services',
        rating: '5.0 Rating',
        projectsCompleted: 'Projects Completed',
        yearsExperience: 'Years Experience'
      },
      services: {
        title: 'Our Services',
        subtitle: 'Professional Construction & Remodeling Solutions',
        ourExpertise: 'Our Expertise',
        primaryService: 'Primary Service',
        additionalServices: 'Additional Premium Services',
        additionalServicesSubtitle: 'Complete remodeling solutions for your property',
        learnMore: 'Learn More',
        pavers: {
          title: 'Brick Pavers',
          description: 'Premium paver installation and design for patios, driveways, and walkways'
        },
        kitchen: {
          title: 'Kitchen Remodeling',
          description: 'Complete kitchen renovations with modern designs and quality craftsmanship'
        },
        bathroom: {
          title: 'Bathroom Remodeling',
          description: 'Luxury bathroom transformations with attention to every detail'
        },
        interior: {
          title: 'Interior Renovation',
          description: 'Full interior remodeling including drywall, flooring, and finishing'
        },
        drywall: {
          title: 'Drywall Services',
          description: 'Professional drywall installation, repair, and finishing'
        },
        general: {
          title: 'General Remodeling',
          description: 'Comprehensive remodeling services for your entire property'
        }
      },
      whyChoose: {
        title: 'Why Choose EDX Construction',
        subtitle: 'Quality, Reliability, and Excellence',
        experience: 'Years of Experience',
        experienceText: 'Proven track record in construction and remodeling',
        quality: 'Quality Guarantee',
        qualityText: 'We stand behind our work with comprehensive warranties',
        satisfaction: 'Customer Satisfaction',
        satisfactionText: '100% commitment to exceeding your expectations',
        professional: 'Licensed & Insured',
        professionalText: 'Fully licensed, insured, and certified professionals'
      },
      gallery: {
        title: 'Featured Projects',
        subtitle: 'See Our Craftsmanship in Action',
        viewFullSize: 'Click to view full size'
      },
      serviceAreas: {
        title: 'Service Areas',
        subtitle: 'Proudly Serving Central Florida'
      },
      finalCta: {
        title: 'Ready to Transform Your Space?',
        subtitle: 'Get your free estimate today and bring your vision to life',
        cta: 'Get Started Now',
        orCall: 'Or call us directly:'
      },
      form: {
        title: 'Request Your Free Estimate',
        name: 'Full Name',
        namePlaceholder: 'John Smith',
        phone: 'Phone Number',
        phonePlaceholder: '(407) 123-4567',
        email: 'Email Address',
        emailPlaceholder: 'john@example.com',
        service: 'Preferred Service',
        servicePlaceholder: 'Select a service',
        serviceOptions: {
          pavers: 'Brick Pavers',
          kitchen: 'Kitchen Remodeling',
          bathroom: 'Bathroom Remodeling',
          interior: 'Interior Renovation',
          drywall: 'Drywall Services',
          general: 'General Remodeling',
          other: 'Other'
        },
        appointment: 'Preferred Appointment Date & Time',
        details: 'Additional Details',
        detailsPlaceholder: 'Tell us about your project...',
        submit: 'Get Free Estimate',
        submitting: 'Submitting...',
        success: 'Thank you! Redirecting you to message us...',
        error: 'Something went wrong. Please try again.'
      },
      footer: {
        tagline: 'Professional Construction & Remodeling Services',
        phone: 'Phone',
        email: 'Email',
        rights: 'All rights reserved.',
        privacy: 'Privacy Policy',
        terms: 'Terms of Service',
        adminAccess: 'Admin Login'
      },
      brickColors: {
        heroTitle: 'Brick Paver Colors & Patterns',
        heroSubtitle: 'Discover our premium selection of brick pavers in a variety of colors, patterns, and finishes to perfectly complement your project',
        exploreCollection: 'Explore Our Collection',
        allCollections: 'All Collections',
        availableOptions: 'Available Options',
        requestSamples: 'Request Samples',
        needHelp: 'Need Help Choosing?',
        helpText: 'Our experts can help you select the perfect paver color and pattern for your project',
        scheduleConsultation: 'Schedule Consultation',
        downloadCatalog: 'Download Catalog'
      },
      shop: {
        title: 'EDX Shop',
        subtitle: 'Show your EDX pride with our exclusive merchandise',
        addToCart: 'Add to Cart',
        viewCart: 'View Cart',
        comingSoon: 'More products coming soon! Check back regularly for new items.'
      }
    }
  },
  es: {
    translation: {
      nav: {
        home: 'Inicio',
        pavers: 'Adoquines',
        brickColors: 'Colores de Ladrillo',
        remodeling: 'Remodelación',
        projects: 'Proyectos',
        about: 'Acerca de',
        contact: 'Contacto',
        shop: 'Tienda'
      },
      hero: {
        title: 'Soluciones Premium de Pavimentación Que Elevan Su Propiedad',
        titleHighlight: 'con Adoquines Premium',
        subtitle: 'Expertos en adoquines y soluciones exteriores de alta gama para proyectos residenciales y comerciales',
        cta: 'Obtener Presupuesto Gratis',
        viewServices: 'Ver Nuestros Servicios',
        rating: 'Calificación 5.0',
        projectsCompleted: 'Proyectos Completados',
        yearsExperience: 'Años de Experiencia'
      },
      services: {
        title: 'Nuestros Servicios',
        subtitle: 'Soluciones Profesionales de Construcción y Remodelación',
        ourExpertise: 'Nuestra Experiencia',
        primaryService: 'Servicio Principal',
        additionalServices: 'Servicios Premium Adicionales',
        additionalServicesSubtitle: 'Soluciones completas de remodelación para su propiedad',
        learnMore: 'Más Información',
        pavers: {
          title: 'Adoquines',
          description: 'Instalación y diseño premium de adoquines para patios, entradas y caminos'
        },
        kitchen: {
          title: 'Remodelación de Cocinas',
          description: 'Renovaciones completas de cocinas con diseños modernos y artesanía de calidad'
        },
        bathroom: {
          title: 'Remodelación de Baños',
          description: 'Transformaciones de baños de lujo con atención a cada detalle'
        },
        interior: {
          title: 'Renovación Interior',
          description: 'Remodelación interior completa incluyendo drywall, pisos y acabados'
        },
        drywall: {
          title: 'Servicios de Drywall',
          description: 'Instalación, reparación y acabado profesional de drywall'
        },
        general: {
          title: 'Remodelación General',
          description: 'Servicios integrales de remodelación para toda su propiedad'
        }
      },
      whyChoose: {
        title: 'Por Qué Elegir EDX Construction',
        subtitle: 'Calidad, Confiabilidad y Excelencia',
        experience: 'Años de Experiencia',
        experienceText: 'Historial comprobado en construcción y remodelación',
        quality: 'Garantía de Calidad',
        qualityText: 'Respaldamos nuestro trabajo con garantías completas',
        satisfaction: 'Satisfacción del Cliente',
        satisfactionText: '100% comprometidos a superar sus expectativas',
        professional: 'Licenciados y Asegurados',
        professionalText: 'Profesionales totalmente licenciados, asegurados y certificados'
      },
      gallery: {
        title: 'Proyectos Destacados',
        subtitle: 'Vea Nuestra Artesanía en Acción',
        viewFullSize: 'Haga clic para ver en tamaño completo'
      },
      serviceAreas: {
        title: 'Áreas de Servicio',
        subtitle: 'Orgullosamente Sirviendo al Centro de Florida'
      },
      finalCta: {
        title: '¿Listo para Transformar Su Espacio?',
        subtitle: 'Obtenga su presupuesto gratuito hoy y haga realidad su visión',
        cta: 'Comenzar Ahora',
        orCall: 'O llámenos directamente:'
      },
      form: {
        title: 'Solicite Su Presupuesto Gratis',
        name: 'Nombre Completo',
        namePlaceholder: 'Juan Pérez',
        phone: 'Número de Teléfono',
        phonePlaceholder: '(407) 123-4567',
        email: 'Correo Electrónico',
        emailPlaceholder: 'juan@example.com',
        service: 'Servicio Preferido',
        servicePlaceholder: 'Seleccione un servicio',
        serviceOptions: {
          pavers: 'Adoquines',
          kitchen: 'Remodelación de Cocina',
          bathroom: 'Remodelación de Baño',
          interior: 'Renovación Interior',
          drywall: 'Servicios de Drywall',
          general: 'Remodelación General',
          other: 'Otro'
        },
        appointment: 'Fecha y Hora Preferida de Cita',
        details: 'Detalles Adicionales',
        detailsPlaceholder: 'Cuéntenos sobre su proyecto...',
        submit: 'Obtener Presupuesto Gratis',
        submitting: 'Enviando...',
        success: '¡Gracias! Redirigiendo para enviarnos un mensaje...',
        error: 'Algo salió mal. Por favor intente de nuevo.'
      },
      footer: {
        tagline: 'Servicios Profesionales de Construcción y Remodelación',
        phone: 'Teléfono',
        email: 'Correo',
        rights: 'Todos los derechos reservados.',
        privacy: 'Política de Privacidad',
        terms: 'Términos de Servicio',
        adminAccess: 'Acceso Admin'
      },
      brickColors: {
        heroTitle: 'Colores y Patrones de Adoquines',
        heroSubtitle: 'Descubra nuestra selección premium de adoquines en una variedad de colores, patrones y acabados para complementar perfectamente su proyecto',
        exploreCollection: 'Explore Nuestra Colección',
        allCollections: 'Todas las Colecciones',
        availableOptions: 'Opciones Disponibles',
        requestSamples: 'Solicitar Muestras',
        needHelp: '¿Necesita Ayuda para Elegir?',
        helpText: 'Nuestros expertos pueden ayudarle a seleccionar el color y patrón perfecto de adoquines para su proyecto',
        scheduleConsultation: 'Programar Consulta',
        downloadCatalog: 'Descargar Catálogo'
      },
      shop: {
        title: 'Tienda EDX',
        subtitle: 'Muestre su orgullo EDX con nuestra mercancía exclusiva',
        addToCart: 'Agregar al Carrito',
        viewCart: 'Ver Carrito',
        comingSoon: '¡Más productos próximamente! Vuelva regularmente para ver nuevos artículos.'
      }
    }
  },
  pt: {
    translation: {
      nav: {
        home: 'Início',
        pavers: 'Pavimentação',
        brickColors: 'Cores de Tijolo',
        remodeling: 'Remodelação',
        projects: 'Projetos',
        about: 'Sobre',
        contact: 'Contato',
        shop: 'Loja'
      },
      hero: {
        title: 'Soluções Premium de Pavimentação Que Elevam Sua Propriedade',
        titleHighlight: 'com Pavimentos Premium',
        subtitle: 'Especialistas em pavimentos e soluções exteriores de alta qualidade para projetos residenciais e comerciais',
        cta: 'Obter Orçamento Grátis',
        viewServices: 'Ver Nossos Serviços',
        rating: 'Avaliação 5.0',
        projectsCompleted: 'Projetos Concluídos',
        yearsExperience: 'Anos de Experiência'
      },
      services: {
        title: 'Nossos Serviços',
        subtitle: 'Soluções Profissionais de Construção e Remodelação',
        ourExpertise: 'Nossa Experiência',
        primaryService: 'Serviço Principal',
        additionalServices: 'Serviços Premium Adicionais',
        additionalServicesSubtitle: 'Soluções completas de remodelação para sua propriedade',
        learnMore: 'Saiba Mais',
        pavers: {
          title: 'Pavimentação',
          description: 'Instalação e design premium de pavimentos para pátios, entradas e calçadas'
        },
        kitchen: {
          title: 'Remodelação de Cozinhas',
          description: 'Renovações completas de cozinhas com designs modernos e artesanato de qualidade'
        },
        bathroom: {
          title: 'Remodelação de Banheiros',
          description: 'Transformações de banheiros de luxo com atenção a cada detalhe'
        },
        interior: {
          title: 'Renovação Interior',
          description: 'Remodelação interior completa incluindo drywall, pisos e acabamentos'
        },
        drywall: {
          title: 'Serviços de Drywall',
          description: 'Instalação, reparo e acabamento profissional de drywall'
        },
        general: {
          title: 'Remodelação Geral',
          description: 'Serviços abrangentes de remodelação para toda a sua propriedade'
        }
      },
      whyChoose: {
        title: 'Por Que Escolher EDX Construction',
        subtitle: 'Qualidade, Confiabilidade e Excelência',
        experience: 'Anos de Experiência',
        experienceText: 'Histórico comprovado em construção e remodelação',
        quality: 'Garantia de Qualidade',
        qualityText: 'Apoiamos nosso trabalho com garantias abrangentes',
        satisfaction: 'Satisfação do Cliente',
        satisfactionText: '100% comprometidos em superar suas expectativas',
        professional: 'Licenciados e Segurados',
        professionalText: 'Profissionais totalmente licenciados, segurados e certificados'
      },
      gallery: {
        title: 'Projetos em Destaque',
        subtitle: 'Veja Nossa Expertise em Ação',
        viewFullSize: 'Clique para ver em tamanho real'
      },
      serviceAreas: {
        title: 'Áreas de Atendimento',
        subtitle: 'Orgulhosamente Atendendo o Centro da Flórida'
      },
      finalCta: {
        title: 'Pronto para Transformar Seu Espaço?',
        subtitle: 'Obtenha seu orçamento gratuito hoje e transforme sua visão em realidade',
        cta: 'Começar Agora',
        orCall: 'Ou ligue diretamente:'
      },
      form: {
        title: 'Solicite Seu Orçamento Gratuito',
        name: 'Nome Completo',
        namePlaceholder: 'João Silva',
        phone: 'Número de Telefone',
        phonePlaceholder: '(407) 123-4567',
        email: 'Endereço de E-mail',
        emailPlaceholder: 'joao@example.com',
        service: 'Serviço Preferido',
        servicePlaceholder: 'Selecione um serviço',
        serviceOptions: {
          pavers: 'Pavimentação',
          kitchen: 'Remodelação de Cozinha',
          bathroom: 'Remodelação de Banheiro',
          interior: 'Renovação Interior',
          drywall: 'Serviços de Drywall',
          general: 'Remodelação Geral',
          other: 'Outro'
        },
        appointment: 'Data e Hora Preferidas para Consulta',
        details: 'Detalhes Adicionais',
        detailsPlaceholder: 'Conte-nos sobre seu projeto...',
        submit: 'Obter Orçamento Grátis',
        submitting: 'Enviando...',
        success: 'Obrigado! Redirecionando para nos enviar uma mensagem...',
        error: 'Algo deu errado. Por favor, tente novamente.'
      },
      footer: {
        tagline: 'Serviços Profissionais de Construção e Remodelação',
        phone: 'Telefone',
        email: 'E-mail',
        rights: 'Todos os direitos reservados.',
        privacy: 'Política de Privacidade',
        terms: 'Termos de Serviço',
        adminAccess: 'Admin Login'
      },
      brickColors: {
        heroTitle: 'Cores e Padrões de Pavimentos',
        heroSubtitle: 'Descubra nossa seleção premium de pavimentos em uma variedade de cores, padrões e acabamentos para complementar perfeitamente seu projeto',
        exploreCollection: 'Explore Nossa Coleção',
        allCollections: 'Todas as Coleções',
        availableOptions: 'Opções Disponíveis',
        requestSamples: 'Solicitar Amostras',
        needHelp: 'Precisa de Ajuda para Escolher?',
        helpText: 'Nossos especialistas podem ajudá-lo a selecionar a cor e o padrão perfeitos de pavimentos para seu projeto',
        scheduleConsultation: 'Agendar Consulta',
        downloadCatalog: 'Baixar Catálogo'
      },
      shop: {
        title: 'Loja EDX',
        subtitle: 'Mostre seu orgulho EDX com nossa mercadoria exclusiva',
        addToCart: 'Adicionar ao Carrinho',
        viewCart: 'Ver Carrinho',
        comingSoon: 'Mais produtos em breve! Volte regularmente para novos itens.'
      }
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    lng: 'en', // Force English as default
    debug: false,
    interpolation: {
      escapeValue: false
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng'
    }
  });

// Force set to English on initialization
if (!localStorage.getItem('i18nextLng')) {
  localStorage.setItem('i18nextLng', 'en');
  i18n.changeLanguage('en');
}

export default i18n;